// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE


function Impl(T) {
  return {};
}

export {
  Impl ,
  
}
/* No side effect */
